<div>
    <h1>Ups, sem bys asi neměl chodit... :)</h1>
    <button type="button" class="primary" (click)="logout()">Odhlásit se</button>
</div>